module.exports = __webpack_public_path__ + "static/media/img47.231c3c4b.jpg";